async function initializeSEPACheckout() {
  if (window._sepa_checkout_initialized) {
    return;
  }

  window._sepa_checkout_initialized = true;
  const apiBaseUrl = window.Shopify.routes.root;
  let cachedCart = null;
  const getSellingPlanId = (shopifyId) => shopifyId.split("/").pop();
  const sepaToNative = Object.fromEntries(
    window.sellingPlanMapping.map((m) => [
      getSellingPlanId(m["sepa"]),
      getSellingPlanId(m["native"]),
    ])
  );

  const getCart = async () => cachedCart ?? (cachedCart = await fetchCart());
  const fetchCart = async () => (await fetch(`${apiBaseUrl}cart.js`)).json();
  const updateCart = async (payload) =>
    (
      await fetch(`${apiBaseUrl}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
    ).json();
  const clearCart = async () =>
    fetch(`${apiBaseUrl}cart/clear.js`, { method: "POST" });
  const addToCart = async (payload) =>
    (
      await fetch(`${apiBaseUrl}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
    ).json();

  const updateCheckoutButtonDisabledState = (disabled) => {
    document
      .querySelectorAll(
        "button.fh-sepa-checkout, shopify-buy-it-now-button>button, button[name='checkout']"
      )
      .forEach((button) => {
        button.disabled = disabled;
      });
  };
  const replacePlans = async (planMapping) => {
    const cart = await fetchCart();
    if (
      !cart.items.some(
        (item) =>
          item.selling_plan_allocation &&
          planMapping[item.selling_plan_allocation.selling_plan.id]
      )
    ) {
      return false;
    }
    const items = cart.items.map((item) => ({
      id: item.variant_id,
      quantity: item.quantity,
      ...(item.selling_plan_allocation
        ? {
            selling_plan:
              planMapping[item.selling_plan_allocation.selling_plan.id] ??
              item.selling_plan_allocation.selling_plan.id,
          }
        : {}),
      properties: item.properties,
    }));
    await clearCart();
    await addToCart({ items, attributes: cart.attributes });
    return true;
  };

  const revertSEPAPlans = async () => {
    const cart = await getCart();
    if (
      !cart.items.some(
        (item) =>
          item.selling_plan_allocation &&
          sepaToNative[item.selling_plan_allocation.selling_plan.id]
      )
    ) {
      return;
    }
    updateCheckoutButtonDisabledState(true);
    if (await replacePlans(sepaToNative)) {
      window.location.reload();
    } else {
      updateCheckoutButtonDisabledState(false);
    }
  };

  const observeCartChanges = () => {
    new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (
          (entry.initiatorType === "xmlhttprequest" ||
            entry.initiatorType === "fetch") &&
          entry.name.includes("/cart/")
        ) {
          cachedCart = null;
          checkCart();
        }
      });
    }).observe({ entryTypes: ["resource"] });
  };

  const checkCart = async () => {
    const cart = await getCart();
    await revertSEPAPlans();
  };

  checkCart();
  observeCartChanges();
  const planMapping = Object.fromEntries(
    window.sellingPlanMapping.map((m) => [
      getSellingPlanId(m["native"]),
      getSellingPlanId(m["sepa"]),
    ])
  );
  const getCartInputs = () => {
    const attributes = document.querySelectorAll(
      "input[name^='attributes['], textarea[name^='attributes[']"
    );
    const note = document.querySelector(
      "textarea[name='note'], input[name='note']"
    );
    const payload = {};
    if (note) {
      payload.note = note.value;
    }
    if (attributes) {
      payload.attributes = Object.fromEntries(
        Array.from(attributes).map((a) => [
          a.name.replace("attributes[", "").replace("]", ""),
          a.value,
        ])
      );
    }
    return payload;
  };

  const handleClick = async (e) => {
    updateCheckoutButtonDisabledState(true);
    await updateCart(getCartInputs());
    await replacePlans(planMapping);

    window.location.href = "/checkout";
  };

  window.fhSepaCheckout = handleClick;
}

window.addEventListener("pageshow", initializeSEPACheckout);
